"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonConstructor = void 0;

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_theme_components_1 = require("@suezenv/react-theme-components");

exports.RadioButtonConstructor = function (_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var _b = __read(formik_1.useField(props), 1),
      _c = _b[0],
      name = _c.name,
      value = _c.value;

  var _d = formik_1.useFormikContext(),
      errors = _d.errors,
      setErrors = _d.setErrors,
      setFieldTouched = _d.setFieldTouched,
      setFieldValue = _d.setFieldValue;

  var removeError = function removeError(name) {
    var newErrors = __assign({}, errors);

    delete newErrors[name];
    setErrors(newErrors);
  };

  var onChange = function onChange(value) {
    setFieldValue(name, value);
    setFieldTouched(name, true);
    removeError(name);
  };

  return react_1.default.createElement(react_theme_components_1.SzRadioButton, __assign({}, props, {
    className: className,
    value: value,
    onChange: onChange
  }));
};

exports.default = exports.RadioButtonConstructor;